import { JsonValue } from '@components/json-editor';

import { IAuthenticatedUserCompany, IWhoAmI, UserOptions } from 'types/authentication';

import { request, unhandledRequest } from './request';

export async function checkSession() {
  const response = await unhandledRequest.get<{ isAuthenticated: boolean }>({
    url: '/auth/session/',
  });

  return response.data;
}

export async function whoAmI() {
  const response = await unhandledRequest.get<IWhoAmI>({
    url: '/auth/whoami/',
  });

  return response?.data;
}

export function signOut() {
  return unhandledRequest.post<void>({
    url: '/auth/logout/',
  });
}

export function checkPassword(email: string, password: string) {
  return request.post<{ isValid: boolean }>({
    url: '/password/check/',
    data: { email, password },
  });
}

export async function switchCompany(company: IAuthenticatedUserCompany) {
  const response = await unhandledRequest.post({
    url: `/auth/switch/${company.id}/`,
  });
  return response.data;
}

type UpdateUserOptionsData = {
  key: keyof UserOptions;
  value: JsonValue;
};

export const updateUserOptions = async (data: UpdateUserOptionsData) => {
  const response = await request.patch({ url: 'v1/user-options/update/', data });
  return response.data;
};
